import { BaseServices, HttpMethod } from './base'
import { BridgeService } from './bridge'

export default ({ accessToken }: { accessToken: string }) => {
  const pathname = process.env.REACT_APP_GET_SEED
  const method = HttpMethod.GET
  const host = process.env.REACT_APP_API_HOST

  const headers: Record<string, string> = {
    accept: 'application/json',
  }

  if (BridgeService.isBrowser() && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  const response = BaseServices.request<{ seed: string }>({
    pathname,
    method,
    host,
    headers,
  })
  return response
}
